export const headerData = {
    "headerTabs": [

        {
            "title": "Administration",
            "id": 1,
            "url": "admin",
            "isHome": true

        }
    ]
}